const envConfig = {
  endpoint: 'https://staging.api.sobrerodas.club/',
  endpointv2: 'https://staging.api.sobrerodas.club/v2/',
};

export default envConfig;
